// import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faClock,
//   faPhone,
//   faFax,
//   faEnvelope,
//   faLocation,
// } from "@fortawesome/free-solid-svg-icons";

// const Phone = () => {
//   return (
//     <div className="mt-20 flex sm:flex-col-1  md:grid-cols-5 lg:flex-row   justify-center items-center  bg-gray-400 p-2">
//       <div>
//         <FontAwesomeIcon icon={faPhone} className="mr-2" beatFade />
//         <span className="text-green-900 font-semibold">(240) 610-3766</span>
//       </div>
//       <span className="mx-4"></span> {/* Added a separator with spacing */}
//       <div>
//         <FontAwesomeIcon icon={faEnvelope} className="mr-2" beatFade />
//         <span className="text-green-900 font-semibold">
//           info@blissfuldayspsychiatry.com
//         </span>
//       </div>
//       <span className="mx-4"></span> {/* Added a separator with spacing */}
//       <div>
//         <FontAwesomeIcon icon={faLocation} className="mr-2" beatFade />
//         <span className="text-green-900 font-semibold">
//           12530 Fairwood Parkway Suite 102, Bowie MD 20720 (virtual)
//         </span>
//       </div>
//       <span className="mx-4"></span> {/* Added a separator with spacing */}
//       <div>
//         <FontAwesomeIcon icon={faFax} className="mr-2" beatFade />
//         <span className="text-green-900 font-semibold">
//           (301) 547 7476 | (301) 238-8019
//         </span>
//       </div>
//       <span className="mx-4"></span> {/* Added a separator with spacing */}
//       <div>
//         {" "}
//         <FontAwesomeIcon icon={faClock} className="mr-2" beatFade />
//         <span className="text-green-900 font-semibold">
//           Mondays to Friday 9am-5pm
//         </span>
//       </div>
//     </div>
//   );
// };

// export default Phone;

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faPhone,
  faFax,
  faEnvelope,
  faLocation,
} from "@fortawesome/free-solid-svg-icons";

const Phone = () => {
  return (
    <div className="mt-20 bg-primary-50 border-y border-primary-200">
      <div className="max-w-screen-xl mx-auto px-6 py-4">
        <div className="flex flex-col lg:flex-row justify-center items-center gap-6 lg:gap-8 text-body-sm">
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faPhone} className="text-primary-600" />
            <a href="tel:2406103766" className="text-neutral-800 font-medium hover:text-primary-600 transition-colors">
              (240) 610-3766
            </a>
          </div>

          <div className="hidden lg:block w-px h-6 bg-primary-200"></div>

          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faEnvelope} className="text-primary-600" />
            <a href="mailto:info@blissfuldayspsych.com" className="text-neutral-800 font-medium hover:text-primary-600 transition-colors">
              info@blissfuldayspsych.com
            </a>
          </div>

          <div className="hidden lg:block w-px h-6 bg-primary-200"></div>

          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faLocation} className="text-primary-600" />
            <span className="text-neutral-800 font-medium text-center lg:text-left">
              12530 Fairwood Parkway Suite 102, Bowie MD 20720
            </span>
          </div>

          <div className="hidden lg:block w-px h-6 bg-primary-200"></div>

          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faClock} className="text-primary-600" />
            <span className="text-neutral-800 font-medium">
              Mon-Fri 9am-5pm
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Phone;
